<template>
    <div class="main d-flex flex-column flex-grow-1" style="min-height: 500px; width: 100%;">
        <router-view />
    </div>
    <Teleport to="body">
        <!-- メッセージボックス（グローバル） -->
        <MessageGlobalDialog ref="messageDialog" @onSelectOK="onMessageOK" />
        <!-- メッセージボックス（グローバル） -->
        <ConfirmGlobalDialog ref="confirmDialog" @onSelectOK="onConfirmOK" @onSelectCancel="onConfirmCancel" />
        <!-- ローディング画面<body>にrelativeは付いている -->
        <Loading ref="loadingDialog" name="globalLoading" />
    </Teleport>

</template>

<script lang="ts">
// @ is an alias to /src
import { Options, Vue } from "vue-class-component";
import Loading from '@/components/Loading.vue'
import { LoadingUtil } from 'lib-vue-v2/util';
import { MessageUtil } from '@/models/Message/MessageUtil';
import MessageGlobalDialog from '@/components/Popup/MessageGlobalDialog.vue';
import ConfirmGlobalDialog from '@/components/Popup/ConfirmGlobalDialog.vue';
import { useModalOnModal } from "lib-vue-v2/composables";
import $ from "jquery";

@Options({
    name: 'App',
    components: {
        MessageGlobalDialog,
        ConfirmGlobalDialog,
        Loading,
    },
})

export default class App extends Vue {
    /**
     * @brief	created
     * @note    インスタンスが生成され､且つデータが初期化された後
     * @return	なし
     */
    public created() {
        useModalOnModal();
    }
    
    /**
     * @brief	mounted
     * @return	なし
     */
    public mounted(): void {
        // モーダルonモーダルの場合はスクロールバーが削除されてしまうためここで設定
        document.addEventListener('hidden.bs.modal', function (event) {
            const target = event.target as HTMLElement | null;
            if (target != null) {
                if (target.closest('.modal')) {
                    var modalCnt = $('.modal:visible').length;
                    if (modalCnt >= 1) {
                        $('body').addClass('modal-open');
                    }
                }
            }
        });

        // メッセージボックス（グローバル）、ローディング画面をグローバル変数にセットする
        const refObj: any = this.$refs;
        MessageUtil.SetMessageBox(refObj.messageDialog);
        MessageUtil.SetConfirmBox(refObj.confirmDialog);
        LoadingUtil.SetLoading(refObj.loadingDialog);
    }

    /**
     * @brief	メッセージでOKボタン押下後の処理
     */
    private onMessageOK(callback: any): void {
        if (null == callback) {
            return;
        }
        callback();
    }

    /**
     * @brief	確認メッセージでOKボタン押下後の処理
     */
    private onConfirmOK(callback: any): void {
        if (null == callback) {
            return;
        }
        callback();
    }

    /**
     * @brief	確認メッセージでキャンセルボタン押下後の処理
     */
    private onConfirmCancel(callback: any): void {
        if (null == callback) {
            return;
        }
        callback();
    }
}

</script>

<style>
#app {
    /* 画面一杯 */
    display: flex;
    height: 100vh;
}

.main {
    /* 画面一杯 */
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
</style>
